import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import Body from './components/Body';
import Footer from './components/Footer';
import Header from './components/Header';
import { PersonProvider } from './context/PersonContext';
import { DialogProvider, DialogContext } from './context/DialogContext';
import { ToastContainer } from 'react-toastify';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Intro from './pages/intro';
import BackLogin from './pages/backdoor';

function App() {
  // 앱이 로드될 때 title에 버전 추가
  useEffect(() => {
    const version = process.env.REACT_APP_VERSION || '1.0.1';
    const baseTitle = '한국실용글쓰기검정 감독관';
    document.title = `${baseTitle} v${version}`;
  }, []);

  return (
    <Router>
      <PersonProvider>
        <DialogProvider>
          <div className="App">
            <ToastContainer />
            <Routes>
              {/* 메인 페이지 - Intro만 표시 */}
              <Route path="/" element={<Intro />} />
              
              {/* 백도어 로그인 페이지 - BackLogin만 표시 */}
              <Route path="/backlogin" element={<BackLogin />} />
              
              {/* 나머지 모든 경로 - Header, Body, Footer 표시 */}
              <Route
                path="*"
                element={
                  <>
                    <Header />
                    <Body />
                    <Footer />
                  </>
                }
              />
            </Routes>
            <DialogContext.Consumer>
              {({ dialog, dialogStyles, closeDialog }) => (
                <Modal
                  isOpen={!!dialog}
                  onRequestClose={closeDialog}
                  contentLabel="다이얼로그"
                  ariaHideApp={false}
                  style={dialogStyles}
                >
                  {dialog}
                </Modal>
              )}
            </DialogContext.Consumer>
          </div>
        </DialogProvider>
      </PersonProvider>
    </Router>
  );
}

export default App;
